import { render, staticRenderFns } from "./AppApprovalButton.vue?vue&type=template&id=7caefa46&"
import script from "./AppApprovalButton.vue?vue&type=script&lang=js&"
export * from "./AppApprovalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports